module.exports = __webpack_public_path__ + "static/sol-k12-section-2-img-c2fe1974da82e8521bcc4d9ffa557c1b.png";